import cookie from 'cookie'

import document from 'common/document'

const COOKIE_NAME = 'remembered'

export const getRememberedUrl = () => {
  return cookie.parse(document.cookie).remembered
}

export const setRememberedUrl = (path: string) => {
  document.cookie = cookie.serialize(COOKIE_NAME, path, { path: '/' })
}

export const removeRememberedUrl = () => {
  document.cookie = cookie.serialize(COOKIE_NAME, undefined, { maxAge: 0, path: '/' })
}

export const getRememberedPath = (rememberedUrl: string) => {
  const fakeLink = document.createElement('a')
  fakeLink.href = rememberedUrl
  const rememeberedPath = `${fakeLink.pathname}${fakeLink.search}`
  return rememeberedPath
}
